module.exports = __webpack_public_path__ + "static/media/rhinobeetle.53b4baf6.png";